// Mirrors the backend policy (md_core.model.structural.connections): every
// Zuganker / Schubverbinder of a library or project has its own short name of
// at most 25 characters; the default is "ZA 01" / "SA 01", "ZA 02", ...
export const CONNECTION_SHORT_NAME_MAX_LENGTH = 25

export const TENSILE_SHORT_NAME_PREFIX = 'ZA'
export const SHEAR_SHORT_NAME_PREFIX = 'SA'

interface WithShortName {
  short_name: string
}

const defaultShortName = (prefix: string, number: number): string =>
  `${prefix} ${String(number).padStart(2, '0')}`

/** The first free "<prefix> nn", counting on from the number of `connections`. */
export const getDefaultConnectionShortName = (
  connections: WithShortName[],
  prefix: string,
): string => {
  const taken = new Set(connections.map(connection => connection.short_name))
  let number = connections.length + 1
  while (taken.has(defaultShortName(prefix, number))) {
    number++
  }
  return defaultShortName(prefix, number)
}

/** The short name a copy of `connection` (duplicate or paste) is proposed with:
 * its own when still free among `connections`, else the next default. */
export const getConnectionShortNameForCopy = (
  connection: Partial<WithShortName>,
  connections: WithShortName[],
  prefix: string,
): string => {
  const shortName = connection.short_name?.trim()
  const isTaken = connections.some(other => other.short_name === shortName)
  return shortName && !isTaken ? shortName : getDefaultConnectionShortName(connections, prefix)
}
